module.exports = __webpack_public_path__ + "static/media/raise-hand.78543942.svg";